import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function WedoNurs() {
  return (
    <section className="centerimg_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="text-center m-auto"
          >
            <h2>
              What Did <span style={{ color: "#198463" }}>We Do?</span>
            </h2>
            <p>
              We researched similar applications and analyzed the issues in them
              to make an application that would be user-friendly.
            </p>
          </Col>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="text-center m-auto"
          >
            <div className="img_come">
              <StaticImage
                src="../../../images/case-studies/save-win/tek_img_05.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1095}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WedoNurs;
